import React, { Fragment, useCallback, useRef } from 'react';
import { useForm } from 'react-hook-form';
import { Link, useHistory } from 'react-router-dom';
import { Col, Row, Button, Form, FormGroup } from 'reactstrap';
import * as Yup from 'yup';
import { useAuth } from '../../../Context/Auth/AuthContext';
import { toast } from 'react-toastify';
// import error from '../../../helpers/ErrorHandling';

const schema = Yup.object().shape({
    email: Yup.string().email('Email invalid!').required('Email is required!'),
    password: Yup.string().required('Password is required!'),
});

export default function SignIn() {
    const history = useHistory();
    const { toggleLoading, signIn } = useAuth();
    const { register, errors, handleSubmit } = useForm({
        validationSchema: schema,
    });
    const form = useRef();
    const webPageUrl = process.env.REACT_APP_WEB_PAGE_URL;
    const onSubmit = useCallback(
        async ({ email, password }) => {
            toggleLoading(true);
            email = email.toLowerCase();
            email = email.trim();
            try {
                await signIn({ email, password });
                history.push('/groups');
            } catch (err) {
                toggleLoading(false);

                if (err.hasOwnProperty('msg') && err.hasOwnProperty('code')) {
                    if (err.code === 460) {
                        history.push(`/confirm/${email}`);
                    }
                } else if (err.message){
                    toast.error(err.message);
                } else {
                    toast.error('An error has ocurred. Please try again later');
                }
            }
        },
        [signIn, history, toggleLoading]
    );

    const keyPressed = useCallback((event) => {
        if (event.key === "Enter") {
            form.current.props.onSubmit();
        }
    }, [form]);

    return (
        <Fragment>
            <div className="h-100 bg-animation">
                <div className="d-flex h-100 justify-content-center align-items-center">
                    <Col md="8" className="mx-auto app-login-box">
                        <a href={webPageUrl} target="_blank" rel="noopener noreferrer">
                            <div className="app-logo-inverse mx-auto mb-3" />
                        </a>

                        <div className="modal-dialog w-100 mx-auto">
                            <div className="modal-content">
                                <div className="modal-body">
                                    <div className="h5 modal-title text-center">
                                        <h4 className="mt-2">
                                            <div>Seniors Living In Neighborhood Kindness</div>
                                            <span>
                                                Please sign in to your account:
                                            </span>
                                        </h4>
                                    </div>
                                    <Form onSubmit={handleSubmit(onSubmit)} ref={form}>
                                        <Row form>
                                            <Col md={12}>
                                                <FormGroup>
                                                    <input
                                                        type="email"
                                                        name="email"
                                                        id="exampleEmail"
                                                        placeholder="Email"
                                                        ref={register}
                                                        className="form-control"
                                                        onKeyPress={keyPressed}
                                                    />
                                                    {errors.email && (
                                                        <p className="error-validation">
                                                            {
                                                                errors.email
                                                                    .message
                                                            }
                                                        </p>
                                                    )}
                                                </FormGroup>
                                            </Col>
                                            <Col md={12}>
                                                <FormGroup>
                                                    <input
                                                        type="password"
                                                        name="password"
                                                        id="examplePassword"
                                                        placeholder="Password"
                                                        ref={register}
                                                        className="form-control"
                                                        onKeyPress={keyPressed}
                                                    />
                                                    {errors.password && (
                                                        <p className="error-validation">
                                                            {
                                                                errors.password
                                                                    .message
                                                            }
                                                        </p>
                                                    )}
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        {/* <FormGroup check>
                                            <Input
                                                type="checkbox"
                                                name="check"
                                                id="exampleCheck"
                                            />
                                            <Label for="exampleCheck" check>
                                                Keep me logged in
                                            </Label>
                                        </FormGroup> */}
                                    </Form>
                                    <div className="divider" />
                                    <h6 className="mb-0">
                                        No account?{' '}
                                        <Link
                                            className="text-primary"
                                            to="/signup"
                                        >
                                            Sign up now
                                        </Link>
                                    </h6>
                                </div>
                                <div className="modal-footer clearfix">
                                    <div className="float-left">
                                        <Link
                                            className="text-primary"
                                            to="/forgot-password"
                                        >
                                            Forgot Password?
                                        </Link>
                                    </div>
                                    <div className="float-right">
                                        <Button
                                            color="primary"
                                            size="lg"
                                            onClick={handleSubmit(onSubmit)}
                                        >
                                            Login
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="text-center text-white opacity-8 mt-3">
                            Copyright &copy; ArchitectUI 2019
                        </div> */}
                    </Col>
                </div>
            </div>
        </Fragment>
    );
}
